import { LocationDataUpload } from '@/location/components/location-data-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function LocationDataImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Upload location data</DialogTitle>
      <DialogContent dividers>
        <LocationDataUpload onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
